import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import EvaluationPrompts from '@/features/evaluation-prompts'

const evaluationPromptsSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  filter: z.string().optional().catch(''),
})

export const Route = createFileRoute('/_authenticated/evaluation-prompts/')({
  validateSearch: evaluationPromptsSearchSchema,
  component: EvaluationPrompts,
})
